import React from 'react';
import {
  Checkbox,
  Combobox,
  Option,
  Button,
  Input,
  Textarea,
  Field,
  Label,
  Text,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  Drawer,
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerBody,
  DrawerFooter,
  Switch,
  Spinner,
  Divider,
  RadioGroup,
  Radio,
  makeStyles,
  tokens
} from '@fluentui/react-components';
import { MessageBarType, Separator } from '@fluentui/react';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { useEffect, useState, useCallback } from 'react';
import { useScrollShadow } from '../../../../commons/functions/useScrollShadow';
import { connect } from 'react-redux';
import { ErrorMessageComponent } from '../../../Error/ErrorMessageComponent';
import { ContractConcept } from '../../../../models/Entities/Contracts/ContractConcept';
import { NewContractConcept } from '../../../../models/Entities/Contracts/NewContractConcept';
import MedicalServiceSelectorComponent from '../../../../commons/component/Inputs/MedicalServiceSelector/MedicalServiceSelectorComponent';
import ProviderSelectorComponent from '../../../../commons/component/Inputs/ProviderSelector/ProviderSelectorComponent';
import { MessageComponent } from '../../../../commons/component/MessageComponent';
import ContractBranchSelectorComponent from '../../../../commons/component/Inputs/ContractBranchSelector/ContractBranchSelector.Component';
import ServiceCategorySelectorComponent from '../../../../commons/component/Inputs/ServiceCategorySelector/ServiceCategorySelector.Component';
import { DateTimeInput } from '../../../../commons/component/Inputs/DateTimeInput/DateTimeInput';
import { ProtocolConceptMultiSelectorComponent } from '../../Protocols/ProtocolContractForm/ProtocolContractConcept/ProtocolConceptMultiSelector/ProtocolConceptMultiselectorComponent';
import { AvailableMedicalService } from '../../../../models/Entities/MedicalServices/AvailableMedicalService';
import { ServiceCategory } from '../../../../models/Entities/ServiceCategory';


// component functions
import * as ComponentFunctions from './ConceptForm.Functions';

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// styles
import './ConceptForm.Styles.css';
import { ContractConceptPaymentSchedule } from '../../../../models/Entities/Contracts/ContractConceptPaymentSchedule';
import { NewContractConceptConcept } from '../../../../models/Entities/Contracts/NewContractConceptConcept';
import { ContractConceptConcept } from '../../../../models/Entities/Contracts/ContractConceptConcept';
import { IValueOriginOption } from './ConceptForm.Functions';
import ContractStageMultiSelectorComponent from '../ContractStageMultiselector/ContractStageMultiSelector.Component';
import { CurrencySelectorComponent } from '../../../../commons/component/Inputs/CurrencySelector/CurrencySelectorComponent';
import { ConceptBranch } from '../../../../models/Entities/Contracts/ConceptBranch';
import { ContractBranch } from '../../../../models/Entities/Contracts/ContractBranch';

const useStyles = makeStyles({
  drawer: {
    '& .fui-DrawerBody': {
      overflowY: 'auto',
    }
  },
  footer: {
    display: 'flex',
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingVerticalL,
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  saveButton: {
    marginRight: tokens.spacingHorizontalS,
  }
});

interface FormValidation {
  success: boolean;
  errors: string[];
}

export const ConceptFormComponent = (props: ComponentFunctions.Props) => {
  const styles = useStyles();
  const [t] = useTranslation();

  const [submittedForm, setSubmittedForm] = useState<boolean>(false);
  const [FormValidationStatus, setFormValidationStatus] = useState<
    FormValidation | undefined
  >();

  const [ContractConceptSaved, setContractConceptSaved] = useState<boolean>(false);
  const [savingSchedules, setSavingSchedules] = useState<boolean>(false);

  // new fields
  //applyToRemoteExecution: boolean,
  //applyToInFaceExecution: boolean,
  //haveDivisionFee: boolean,
  //divisionFeeValue: number,

  const [AddedConceptId, setAddedConceptId] = useState<number>();

  // state variables
  const [conceptId, setConceptId] = useState<number>();
  const [conceptName, setConceptName] = useState<string>();
  const [conceptDescription, setConceptDescription] = useState<string>();
  const [isIncludeInVisit, setIsIncludeInVisit] = useState<boolean>(false);
  const [groupWithInTheVisit, setGroupWithInTheVisit] = useState<boolean>(false);
  const [visitConceptRelationship, setVisitConceptRelationship] = useState<string | null>('');
  const [isOptional, setIsOptional] = useState<boolean>(true);
  const [isManagedByCoordinator, setIsManagedByCoordinator] = useState<boolean>(false);
  const [applyToRemoteExecution, setApplyToRemoteExecution] = useState<boolean>(true);
  const [applyToInFaceExecution, setApplyToInFaceExecution] = useState<boolean>(true);
  const [applyToPhoneExecution, setApplyToPhoneExecution] = useState<boolean>(true);
  const [applyToPreScreeningExecution, setApplyToPreScreeningExecution] = useState<boolean>(true);
  const [applyToScreeningExecution, setApplyToScreeningExecution] = useState<boolean>(true);
  const [applyToRandomizationExecution, setApplyToRandomizationExecution] = useState<boolean>(true);
  const [applyToTreatmentExecution, setApplyToTreatmentExecution] = useState<boolean>(true);
  const [applyToFollowUpExecution, setApplyToFollowUpExecution] = useState<boolean>(true);
  const [applyToUnScheduledExecution, setApplyToUnScheduledExecution] = useState<boolean>(true);
  const [applyToEarlyTerminationExecution, setApplyToEarlyTerminationExecution] = useState<boolean>(true);
  const [applyToFailvisitExecution, setApplyToFailvisitExecution] = useState<boolean>(true);
  const [haveDivisionFee, setHaveDivisionFee] = useState<boolean>(false);
  const [divisionFeeValue, setDivisionFeeValue] = useState<number>(0);
  const [isMedicalService, setIsMedicalService] = useState<boolean>(false);
  const [medicalServiceId, setMedicalServiceId] = useState<number>();
  const [settlementSettingOptionSelected, setSettlementSettingOptionSelected] = useState<ComponentFunctions.ISettlementOption | undefined>();
  const [settlementSetting, setSettlementSetting] = useState<number>();
  const [settlementPeriod, setSettlementPeriod] = useState<number>();
  const [valuationTypeOptionSelected, setValuationTypeOptionSelected] = useState<ComponentFunctions.IValueOriginOption | undefined>();
  const [valuationType, setValuationType] = useState<number>(1);
  const [priceValue, setPriceValue] = useState<number>(0);
  const [remoteFixedValue, setRemoteFixedValue] = useState<number>(0);
  const [phoneFixedValue, setPhoneFixedValue] = useState<number>(0);
  const [haveRepetitionPrice, setHaveRepetitionPrice] = useState<boolean>(false);
  const [repetitionPriceValue, setRepetitionPriceValue] = useState<number>();
  const [haveEarlyDiscontinuationPrice, setHaveEarlyDiscontinuationPrice] = useState<boolean>(false);
  const [earlyDiscontinuationPrice, setEarlyDiscontinuationPrice] = useState<number>();
  const [percentageValue, setPercentageValue] = useState<number>();
  const [percetageBaseOptionSelected, setPercetageBaseOptionSelected] = useState<ComponentFunctions.IPercentageOriginOption | undefined>();
  const [percentageBase, setPercentageBase] = useState<number>();
  const [maxCostPrice, setMaxCostPrice] = useState<number>();
  const [priceListOrigin, setPriceListOrigin] = useState<number>();
  const [haveCost, setHaveCost] = useState<boolean>(false);
  const [costSetting, setCostSetting] = useState<number>();
  const [serviceCategory, setServiceCategory] = useState<string[]>([]);
  const [costSettingOptionSelected, setCostSettingOptionSelected] = useState<ComponentFunctions.ICostOptions | undefined>();
  const [percentageCostValue, setPercentageCostValue] = useState<number>();
  const [fixedCostValue, setFixedCostValue] = useState<number>();
  const [costPriceListOrigin, setCostPriceListOrigin] = useState<number>();
  const [costProviderId, setCostProviderId] = useState<number>();
  const [amountToIncludePerSettlement, setAmountToIncludePerSettlement] = useState<number>();
  const [excludeParticularPatient, setExcludeParticularPatient] = useState<boolean>(false);
  const [takeOnlyParticularPatient, setTakeOnlyParticularPatient] = useState<boolean>(false);
  const [calculateType, setCalculateType] = useState<number>();
  const [needAggrupation, setNeedAggrupation] = useState<boolean>(false);
  const [aggrupationSegment, setAggrupationSegment] = useState<number>();
  const [quantityToSettle, setQuantityToSettle] = useState<number>(1);
  const [maxQuantityToSettle, setMaxQuantityToSettle] = useState<number>(1);
  const [capToApply, setCapToApply] = useState<number>(0);
  const [haveGenderFilter, setHaveGenderFilter] = useState<boolean>(false);
  const [appliesToMen, setAppliesToMen] = useState<boolean>(true);
  const [appliesToWomen, setAppliesToWomen] = useState<boolean>(true);
  const [appliesToWomenOfFertileAge, setAppliesToWomenOfFertileAge] = useState<boolean>(true);
  const [appliesToWomenOfNonFertileAge, setAppliesToWomenOfNonFertileAge] = useState<boolean>(true);
  const [appliesBetweenAges, setAppliesBetweenAges] = useState<boolean>(false);
  const [appliesAgesFrom, setAppliesAgesFrom] = useState<number>();
  const [appliesAgesTo, setAppliesAgesTo] = useState<number>();
  const [haveOverhead, setHaveOverhead] = useState<boolean>(false);
  const [overheadValue, setOverheadValue] = useState<number>(0);
  const [averageOverheadValue, setAverageOverheadValue] = useState<number>();
  const [ignoreDecimal, setIgnoreDecimal] = useState<boolean>(false);
  const [initialPeriodDate, setInitialPeriodDate] = useState<Date | null | undefined>();
  const [haveRetroactivity, setHaveRetroactivity] = useState<boolean>(false);
  const [retroactivityValue, setRetroactivityValue] = useState<number>();
  const [retroactivityRemoteValue, setRetroactivityRemoteValue] = useState<number>();
  const [retroactivityDateFrom, setRetroactivityDateFrom] = useState<Date | null | undefined>();
  const [haveWithdrawal, setHaveWithdrawal] = useState<boolean>(false);
  const [withdrawalValue, setWithdrawalValue] = useState<number>();

  // display string states for decimal inputs (avoids loss of decimal point during typing)
  const [priceValueStr, setPriceValueStr] = useState<string>('0');
  const [remoteFixedValueStr, setRemoteFixedValueStr] = useState<string>('0');
  const [phoneFixedValueStr, setPhoneFixedValueStr] = useState<string>('0');
  const [percentageValueStr, setPercentageValueStr] = useState<string>('');
  const [withdrawalValueStr, setWithdrawalValueStr] = useState<string>('');
  const [divisionFeeValueStr, setDivisionFeeValueStr] = useState<string>('0');
  const [averageOverheadValueStr, setAverageOverheadValueStr] = useState<string>('');
  const [repetitionPriceValueStr, setRepetitionPriceValueStr] = useState<string>('');
  const [earlyDiscontinuationPriceStr, setEarlyDiscontinuationPriceStr] = useState<string>('');
  const [fixedCostValueStr, setFixedCostValueStr] = useState<string>('');
  const [applyWithholdingOnConceptValues, setApplyWithholdingOnConceptValues] = useState<boolean>(false);
  const [applyOnRandomizedPatients, setApplyOnRandomizedPatients] = useState<boolean>(false);
  const [applyEachXItems, setApplyEachXItems] = useState<number>();
  const [conceptPaymentSchedule, setConceptPaymentSchedule] = useState<ContractConceptPaymentSchedule[]>([]);
  const [conceptAssociated, setConceptsAssociated] = useState<ContractConceptConcept[] | NewContractConceptConcept[]>([]);
  const [filterByBranches, setFilterByBranches] = useState<boolean>(false);
  const [branches, setBranches] = useState<ConceptBranch[]>([]);
  const [currency, setCurrency] = useState<string>(props.Contract?.contractCurrency);

  const handleBranchSelection = (selectedBranches: ConceptBranch[]) => {
    setBranches(selectedBranches);
  };

  //load necesary data
  useEffect(() => {
    props.GetContractById(props.ContractId);
  }, []);

  useEffect(() => {
    if (props.Contract) {
      if (props.ContractConceptId) props.GetContractConceptById(props.ContractConceptId);
    }
  }, [props.Contract === undefined]);

  useEffect(() => {
    if (props.Concept) {
      props.GetAllContractConceptConcepts && props.GetAllContractConceptConcepts(props.ContractId, props.ContractAddendumId, props.Concept.id);
      props.GetAllContractsConceptPaymentSchedule && props.GetAllContractsConceptPaymentSchedule(props.ContractId, props.ContractAddendumId, props.Concept.id);
    }
  }, [props.ContractConceptId]);


  // save control
  useEffect(() => {
    console.log('Add useEffect triggered:', {
      submittedForm,
      isAdded: props.isAdded,
      isAdding: props.isAdding,
      ContractConceptId: props.ContractConceptId,
      ConceptsLength: props.Concepts?.length
    });
    if (submittedForm && props.isAdded && !props.isAdding && props.ContractConceptId === undefined) {
      //alert('Concept added successfully');
      var newConcept: ContractConcept | undefined = props.Concepts?.at(-1);
      //alert('New Concept ID: ' + newConcept?.id);
      setAddedConceptId(newConcept?.id);
      //alert('Add concept as saved');
      setContractConceptSaved(true);
      //alert('ValuationType' + valuationType + ' SettlementSetting: ' + settlementSetting);
      if (valuationType !== 5 && settlementSetting !== 4) {
        //alert('Dismissing panel');
        ResetForm();
        props.dismissPanel();
      } else {
        setSavingSchedules(true);
      }
    }
  }, [props.isAdded, props.isAdding]);

  // save control
  useEffect(() => {
    console.log('Update useEffect triggered:', {
      submittedForm,
      isUpdated: props.isUpdated,
      isUpdating: props.isUpdating,
      ContractConceptId: props.ContractConceptId,
      ConceptsLength: props.Concepts?.length
    });
    //alert('ValuationType' + valuationType + ' SettlementSetting: ' + settlementSetting);
    if (submittedForm && props.isUpdated && !props.isUpdating && props.ContractConceptId !== undefined) {
      //alert('Add concept as saved');
      setContractConceptSaved(true);
      if (valuationType !== 5 && settlementSetting !== 4) {
        //alert('dismissing panel');
        ResetForm();
        props.dismissPanel();
      } else {
        setSavingSchedules(true);
      }
    }
  }, [props.isUpdated, props.isUpdating]);

  useEffect(() => {
    if (props.Concept) {
      setConceptId(props.Concept.concept?.id);
      setConceptName(props.Concept.concept?.conceptName);
      setConceptDescription(props.Concept.concept?.conceptDescription);
      setIsIncludeInVisit(props.Concept.isIncludeInVisit);
      setGroupWithInTheVisit(props.Concept.groupWithInTheVisit);
      setVisitConceptRelationship(props.Concept.visitConceptRelationship);
      setIsOptional(props.Concept.isOptional);
      setIsManagedByCoordinator(props.Concept.isManagedByCoordinator);
      setApplyToRemoteExecution(props.Concept.applyToRemoteExecution);
      setApplyToInFaceExecution(props.Concept.applyToInFaceExecution);
      setApplyToPhoneExecution(props.Concept.applyToPhoneExecution);
      setApplyToPreScreeningExecution(props.Concept.applyToPreScreeningExecution);
      setApplyToScreeningExecution(props.Concept.applyToScreeningExecution);
      setApplyToRandomizationExecution(props.Concept.applyToRandomizationExecution);
      setApplyToTreatmentExecution(props.Concept.applyToTreatmentExecution);
      setApplyToFollowUpExecution(props.Concept.applyToFollowUpExecution);
      setApplyToUnScheduledExecution(props.Concept.applyToUnScheduledExecution);
      setApplyToEarlyTerminationExecution(props.Concept.applyToEarlyTerminationExecution);
      setApplyToFailvisitExecution(props.Concept.applyToFailvisitExecution);
      setHaveDivisionFee(props.Concept.haveDivisionFee);
      setDivisionFeeValue(props.Concept.divisionFeeValue);
      setIsMedicalService(props.Concept.isMedicalService);
      setMedicalServiceId(props.Concept.medicalServiceId);
      setSettlementSetting(props.Concept.settlementSetting);
      setSettlementSettingOptionSelected(ComponentFunctions.SettlementOptions.find((option: ComponentFunctions.ISettlementOption) => option.key.toString() === props.Concept.settlementSetting.toString()));
      setSettlementPeriod(props.Concept.settlementPeriod);
      setValuationType(props.Concept.valuationType);
      setValuationTypeOptionSelected(ComponentFunctions.ValueOriginOptions.find((option: ComponentFunctions.IValueOriginOption) => option.key === props.Concept.valuationType.toString()));
      setPriceValue(props.Concept.priceValue || 0);
      setHaveRepetitionPrice(props.Concept.haveRepetitionPrice);
      setRepetitionPriceValue(props.Concept.repetitionPriceValue);
      setHaveEarlyDiscontinuationPrice(props.Concept.haveEarlyDiscontinuationPrice);
      setEarlyDiscontinuationPrice(props.Concept.earlyDiscontinuationPrice);
      setPercentageValue(props.Concept.percentageValue);
      setPercetageBaseOptionSelected(ComponentFunctions.PercentageOriginOptions.find((option: ComponentFunctions.IPercentageOriginOption) => option.key === props.Concept.percentageBase?.toString()) || undefined);
      setMaxCostPrice(props.Concept.maxCostPrice);
      setPriceListOrigin(props.Concept.priceListOrigin);
      setHaveCost(props.Concept.haveCost);
      setCostSettingOptionSelected(ComponentFunctions.ConceptCostOptions.find((option: ComponentFunctions.ICostOptions) => option.key === props.Concept.costSetting?.toString()) || undefined);
      setCostSetting(props.Concept.costSetting);
      setServiceCategory(props.Concept.serviceCategory ? [props.Concept.serviceCategory] : []);
      setPercentageCostValue(props.Concept.percentageCostValue);
      setPercentageBase(props.Concept.percentageBase);
      setFixedCostValue(props.Concept.fixedCostValue);
      setCostPriceListOrigin(props.Concept.costPriceListOrigin);
      setCostProviderId(props.Concept.costProviderId);
      setAmountToIncludePerSettlement(props.Concept.amountToIncludePerSettlement);
      setExcludeParticularPatient(props.Concept.excludeParticularPatient);
      setTakeOnlyParticularPatient(props.Concept.takeOnlyParticularPatient);
      setCalculateType(props.Concept.calculateType);
      setNeedAggrupation(props.Concept.needAgrupation);
      setAggrupationSegment(props.Concept.agroupationSegment);
      setQuantityToSettle(props.Concept.quantityToSettle);
      setMaxQuantityToSettle(props.Concept.maxQuantityToSettle);
      setHaveGenderFilter(props.Concept.haveGenderFilter);
      setAppliesToMen(props.Concept.appliesToMen);
      setAppliesToWomen(props.Concept.appliesToWomen);
      setAppliesToWomenOfFertileAge(props.Concept.appliesToWomenOfFertileAge);
      setAppliesToWomenOfNonFertileAge(props.Concept.appliesToWomenOfNonFertileAge);
      setAppliesBetweenAges(props.Concept.appliesToAgeBetween);
      setAppliesAgesFrom(props.Concept.ageFrom);
      setAppliesAgesTo(props.Concept.ageTo);
      setHaveOverhead(props.Concept.haveOverhead);
      setOverheadValue(props.Concept.overheadValue);
      setAverageOverheadValue(props.Concept.averageOverheadValue);
      setIgnoreDecimal(props.Concept.ignoreDecimal);
      // added fields
      setInitialPeriodDate(props.Concept.initialPeriodDate);
      setRemoteFixedValue(props.Concept.remoteFixedValue || 0);
      setPhoneFixedValue(props.Concept.phoneFixedValue || 0);
      setHaveRetroactivity(props.Concept.haveRetroactivity);
      setRetroactivityValue(props.Concept.retroactivityValue);
      setRetroactivityRemoteValue(props.Concept.retroactivityRemoteValue);
      setRetroactivityDateFrom(props.Concept.retroactivityDateFrom);
      setHaveWithdrawal(props.Concept.haveWithdrawal);
      setWithdrawalValue(props.Concept.withdrawalValue);
      setNeedAggrupation(props.Concept.needAgrupation);
      setAggrupationSegment(props.Concept.agroupationSegment);
      setAverageOverheadValue(props.Concept.averageOverheadValue);
      setApplyWithholdingOnConceptValues(props.Concept.applyWithholdingOnConceptValues);
      setApplyOnRandomizedPatients(props.Concept.takeOnlyRandomizedPatients);
      setApplyEachXItems(props.Concept.applyEachXItems);
      setFilterByBranches(props.Concept.filterByBranches);
      setBranches(props.Concept.branches || []);
      // end added fields
      // sync display string states
      setPriceValueStr((props.Concept.priceValue || 0).toString());
      setRemoteFixedValueStr((props.Concept.remoteFixedValue || 0).toString());
      setPhoneFixedValueStr((props.Concept.phoneFixedValue || 0).toString());
      setPercentageValueStr(props.Concept.percentageValue?.toString() ?? '');
      setWithdrawalValueStr(props.Concept.withdrawalValue?.toString() ?? '');
      setDivisionFeeValueStr(props.Concept.divisionFeeValue?.toString() ?? '0');
      setAverageOverheadValueStr(props.Concept.averageOverheadValue?.toString() ?? '');
      setRepetitionPriceValueStr(props.Concept.repetitionPriceValue?.toString() ?? '');
      setEarlyDiscontinuationPriceStr(props.Concept.earlyDiscontinuationPrice?.toString() ?? '');
      setFixedCostValueStr(props.Concept.fixedCostValue?.toString() ?? '');
    }
  }, [props.ContractConceptId]);

  const ResetForm = () => {
    setConceptName(undefined);
    setConceptDescription(undefined);
    setSubmittedForm(false);
    setFormValidationStatus(undefined);
    setConceptId(undefined);
    setIsIncludeInVisit(false);
    setGroupWithInTheVisit(false);
    setIsOptional(true);
    setIsManagedByCoordinator(false);
    setApplyToRemoteExecution(true);
    setApplyToInFaceExecution(true);
    setApplyToPhoneExecution(true);
    setApplyToPreScreeningExecution(true);
    setApplyToScreeningExecution(true);
    setApplyToRandomizationExecution(true);
    setApplyToTreatmentExecution(true);
    setApplyToFollowUpExecution(true);
    setApplyToUnScheduledExecution(true);
    setApplyToEarlyTerminationExecution(true);
    setApplyToFailvisitExecution(true);
    setHaveDivisionFee(false);
    setDivisionFeeValue(0);
    setIsMedicalService(false);
    setMedicalServiceId(undefined);
    setSettlementSetting(undefined);
    setSettlementSettingOptionSelected(undefined);
    setSettlementPeriod(undefined);
    setValuationType(1);
    setValuationTypeOptionSelected(undefined);
    setPriceValue(0);
    setHaveRepetitionPrice(false);
    setRepetitionPriceValue(undefined);
    setHaveEarlyDiscontinuationPrice(false);
    setEarlyDiscontinuationPrice(undefined);
    setPercentageValue(undefined);
    setPercetageBaseOptionSelected(undefined);
    setPercentageBase(undefined);
    setMaxCostPrice(undefined);
    setPriceListOrigin(undefined);
    setHaveCost(false);
    setCostSetting(undefined);
    setCostSettingOptionSelected(undefined);
    setServiceCategory([]);
    setPercentageCostValue(undefined);
    setFixedCostValue(undefined);
    setCostPriceListOrigin(undefined);
    setCostProviderId(undefined);
    setAmountToIncludePerSettlement(undefined);
    setExcludeParticularPatient(false);
    setTakeOnlyParticularPatient(false);
    setCalculateType(undefined);
    setNeedAggrupation(false);
    setAggrupationSegment(undefined);
    setQuantityToSettle(1);
    setMaxQuantityToSettle(1);
    setHaveGenderFilter(false);
    setAppliesToMen(true);
    setAppliesToWomen(true);
    setAppliesToWomenOfFertileAge(true);
    setAppliesToWomenOfNonFertileAge(true);
    setAppliesBetweenAges(false);
    setAppliesAgesFrom(undefined);
    setAppliesAgesTo(undefined);
    setHaveOverhead(false);
    setOverheadValue(0);
    setAverageOverheadValue(undefined);
    setIgnoreDecimal(false);
    setInitialPeriodDate(undefined);
    setRemoteFixedValue(0);
    setPhoneFixedValue(0);
    setHaveRetroactivity(false);
    setRetroactivityValue(undefined);
    setRetroactivityRemoteValue(undefined);
    setRetroactivityDateFrom(undefined);
    setHaveWithdrawal(false);
    setWithdrawalValue(undefined);
    setVisitConceptRelationship('');
    setPhoneFixedValue(0);
    setServiceCategory([]);
    setApplyWithholdingOnConceptValues(false);
    setApplyOnRandomizedPatients(false);
    setApplyEachXItems(undefined);
    setContractConceptSaved(false);
    setSavingSchedules(false);
    setAddedConceptId(undefined);
    setCapToApply(0);
    setFilterByBranches(false);
    setBranches([]);
    // reset display string states
    setPriceValueStr('0');
    setRemoteFixedValueStr('0');
    setPhoneFixedValueStr('0');
    setPercentageValueStr('');
    setWithdrawalValueStr('');
    setDivisionFeeValueStr('0');
    setAverageOverheadValueStr('');
    setRepetitionPriceValueStr('');
    setEarlyDiscontinuationPriceStr('');
    setFixedCostValueStr('');
  };

  const onFinishedSavingHandler = useCallback((status: boolean) => {
    if (status && ContractConceptSaved) {
      setSavingSchedules(false);
      ResetForm();
      props.dismissPanel();
    }
  }, [ContractConceptSaved, props.dismissPanel]);

  const onChangeValuationTypeSelection = (
    event: React.FormEvent<HTMLDivElement>,
    item?: IValueOriginOption
  ) => {
    setValuationTypeOptionSelected(item);
    setValuationType(Number(item?.key));
  }

  const onChangeMedicalServiceIdSelection = (
    medicalservice?: AvailableMedicalService | undefined
  ) => {
    setMedicalServiceId(medicalservice?.id);
  }

  const onChangePriceTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setPriceValue(Number(newValue));
  }

  const onChangePercentageTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setPercentageValue(Number(newValue));
  }

  const onChangeMaxCostPriceTextFieldValue = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    setMaxCostPrice(Number(newValue));
  }

  // -----------------------------------------------------

  const onChangeConceptSelection = (
    concepts: ContractConcept[]
  ) => {
    var currentConceptAssociated: (ContractConceptConcept | NewContractConceptConcept)[] = [];

    concepts?.forEach(concept => {

      currentConceptAssociated = [...currentConceptAssociated, {
        contractConceptId: props.Concept?.id,
        relatedContractConceptId: concept.id,
        isSelect: concept.isSelected
      }];
    });
    setConceptsAssociated(currentConceptAssociated);
    console.log('conceptos asociados', currentConceptAssociated);
  };

  const onAddConceptToConcept = (concept: ContractConcept) => {
    //alert('agrega concepto' + concept.id);
    // // get if concept is already associated
    // var auxConcept = props.Concept?.concepts?.find(concept => 
    //   concept.relatedContractConceptId === concept.id
    // );

    // if (!auxConcept) {
    //   setConceptsAssociated([...conceptAssociated, {
    //     contractConceptId: props.Concept.id,
    //     relatedContractConceptId: concept.id
    //   }]);
    // } else {
    //   setConceptsAssociated([...conceptAssociated, auxConcept]);
    // }
  }

  const onRemoveConceptFromConcept = (concept: ContractConcept) => {
    // alert('quita concepto' + concept.id);
    // // console.log('conceptos asociados', conceptAssociated);
    // setConceptsAssociated(conceptAssociated?.filter(conceptAssociated => conceptAssociated?.relatedContractConceptId !== concept.id));
  }

  // const onChangeHaveCost = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveCost(checked || false);
  // }

  // const onChangeCostSetting = (
  //   event: React.FormEvent<HTMLDivElement>,
  //   option?: ComponentFunctions.ICostOptions
  // ) => {
  //   setCostSettingOptionSelected(option);
  //   setCostSetting(Number(option?.key) || undefined);
  // }

  // const onChangeFixedCostTextFieldValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setFixedCostValue(Number(newValue));
  // }

  // const onChangePercentageCostTextFieldValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setPercentageCostValue(Number(newValue));
  // }

  // const onChangeHaveEarlyDiscontinuationPrice = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveEarlyDiscontinuationPrice(checked || false);
  // };

  // const onChangeEarlyDiscontinuationPriceTextFieldValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setEarlyDiscontinuationPrice(Number(newValue));
  // }

  // const onChangeAgroupationTag = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setNeedAggrupation(checked || false);
  // }

  // const onChangeAgroupationSegment = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setAggrupationSegment(Number(newValue));
  // }

  // const onChangePaymentSchedule = (
  //   paymentSchedule: ContractConceptPaymentSchedule[]
  // ) => {
  //   console.log(paymentSchedule);
  //   setConceptPaymentSchedule(paymentSchedule);
  // };


  // const onChangeQuantityToSettle = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setQuantityToSettle(Number(newValue));
  // }

  // const onChangeAmountToIncludePerSettlement = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setAmountToIncludePerSettlement(Number(newValue));
  // }

  // const onChangeExcludeParticularPatient = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setExcludeParticularPatient(checked || false);
  // }

  // const onChangeTakeOnlyParticularPatient = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setTakeOnlyParticularPatient(checked || false);
  // }

  // const onChangeMaxQuantityToSettle = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setMaxQuantityToSettle(Number(newValue));
  // }

  // const onChangeHaveGenderFilter = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveGenderFilter(checked || false);
  // }

  // const onChangeAppliesBetweenAges = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesBetweenAges(checked || false);
  // }

  // const onChangeAppliesToMen = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToMen(checked || false);
  // }

  // const onChangeAppliesToWomen = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToWomen(checked || false);
  // }

  // const onChangeAppliesToWomenOfFertileAge = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToWomenOfFertileAge(checked || false);
  // }

  // const onChangeAppliesToWomenOfNonFertileAge = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setAppliesToWomenOfNonFertileAge(checked || false);
  // }

  // const onChangeHaveOverhead = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveOverhead(checked || false);
  // }

  // const onChangeOverheadValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setOverheadValue(Number(newValue));
  // }

  // const onChangeAvergaveOverheadValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setAverageOverheadValue(Number(newValue));
  //   // var auxPriceWithoutOverheadValue = priceValue && ((priceValue * 100) / (100 + avergaveOverheadValue)) || 0;
  //   // priceValue && setOverheadValue(priceValue - auxPriceWithoutOverheadValue);
  // }

  // // withdrawal fields

  // const onChangeHaveWithdrawal = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveWithdrawal(checked || false);
  // }

  // const onChangeWithdrawalValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setWithdrawalValue(Number(newValue));
  // }

  // const onChangeApplyToRemoteExecution = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setApplyToRemoteExecution(checked || false);
  // }

  // const onChangeApplyToInFaceExecution = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setApplyToInFaceExecution(checked || false);
  // }

  // const onChangeHaveDivisionFee = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveDivisionFee(checked || false);
  // }

  // const onChangeDivisionFeeValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setDivisionFeeValue(Number(newValue));
  // }

  // // retroactivity fields
  // const onChangeHaveRetroactivity = (
  //   ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined,
  //   checked?: boolean | undefined
  // ) => {
  //   setHaveRetroactivity(checked || false);
  // }

  // const onChangeRetroactivityValue = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   newValue?: string
  // ) => {
  //   setRetroactivityValue(Number(newValue));
  // }

  // handler Actions
  const HandleSaveForm = () => {
    console.log('HandleSaveForm called', {
      conceptName,
      conceptDescription,
      ContractConceptId: props.ContractConceptId,
      serviceCategory: serviceCategory,
      serviceCategoryValue: serviceCategory && serviceCategory.length > 0 ? serviceCategory[0] : undefined
    });
    setContractConceptSaved(false);
    setSubmittedForm(true);
    if (ValidateForm()) {
      let CurrentValues: ContractConcept | NewContractConcept;
      if (props.ContractConceptId) {
        CurrentValues = {
          id: props.ContractConceptId!,
          isSelected: props.Concept?.isSelected ?? false,
          isUnselected: props.Concept?.isUnselected ?? false,
          contractId: props.ContractId,
          contractAddendumId: props.ContractAddendumId,
          conceptId: conceptId!,
          concept: {
            id: conceptId!,
            conceptName: conceptName!,
            conceptDescription: conceptDescription!,
            conceptReferenceId: '1'
          },
          conceptCurrency: currency!,
          isIncludeInVisit: isIncludeInVisit,
          groupWithInTheVisit: groupWithInTheVisit ?? false,
          visitConceptRelationship: visitConceptRelationship,
          isOptional: isOptional,
          isManagedByCoordinator: isManagedByCoordinator,
          applyToRemoteExecution: applyToRemoteExecution,
          applyToInFaceExecution: applyToInFaceExecution,
          applyToPhoneExecution: applyToPhoneExecution,
          applyToPreScreeningExecution: applyToPreScreeningExecution,
          applyToScreeningExecution: applyToScreeningExecution,
          applyToRandomizationExecution: applyToRandomizationExecution,
          applyToTreatmentExecution: applyToTreatmentExecution,
          applyToFollowUpExecution: applyToFollowUpExecution,
          applyToUnScheduledExecution: applyToUnScheduledExecution,
          applyToEarlyTerminationExecution: applyToEarlyTerminationExecution,
          haveDivisionFee: haveDivisionFee,
          divisionFeeValue: divisionFeeValue!,
          isMedicalService: isMedicalService!,
          medicalServiceId: medicalServiceId!,
          settlementSetting: settlementSetting!,
          settlementPeriod: settlementPeriod!,
          valuationType: valuationType!,
          priceValue: priceValue!,
          phoneFixedValue: phoneFixedValue,
          remoteFixedValue: remoteFixedValue,
          haveRepetitionPrice: haveRepetitionPrice!,
          repetitionPriceValue: repetitionPriceValue!,
          haveEarlyDiscontinuationPrice: haveEarlyDiscontinuationPrice!,
          earlyDiscontinuationPrice: earlyDiscontinuationPrice!,
          percentageValue: percentageValue!,
          maxCostPrice: maxCostPrice!,
          priceListOrigin: priceListOrigin!,
          haveCost: haveCost!,
          costSetting: costSetting!,
          serviceCategory: serviceCategory && serviceCategory.length > 0 ? serviceCategory[0] : undefined,
          percentageCostValue: percentageCostValue!,
          percentageBase: percentageBase!,
          fixedCostValue: fixedCostValue!,
          costPriceListOrigin: costPriceListOrigin!,
          costProviderId: costProviderId!,
          amountToIncludePerSettlement: amountToIncludePerSettlement!,
          excludeParticularPatient: excludeParticularPatient!,
          takeOnlyParticularPatient: takeOnlyParticularPatient!,
          calculateType: calculateType!,
          needAgrupation: needAggrupation!,
          agroupationSegment: aggrupationSegment!,
          quantityToSettle: quantityToSettle!,
          maxQuantityToSettle: maxQuantityToSettle!,
          haveGenderFilter: haveGenderFilter!,
          appliesToMen: appliesToMen!,
          appliesToWomen: appliesToWomen!,
          appliesToWomenOfFertileAge: appliesToWomenOfFertileAge!,
          appliesToWomenOfNonFertileAge: appliesToWomenOfNonFertileAge!,
          appliesToAgeBetween: appliesBetweenAges,
          ageFrom: appliesAgesFrom,
          ageTo: appliesAgesTo,
          haveOverhead: haveOverhead,
          overheadValue: overheadValue,
          averageOverheadValue: averageOverheadValue,
          ignoreDecimal: ignoreDecimal,
          // added fileds
          initialPeriodDate: initialPeriodDate,
          haveRetroactivity: haveRetroactivity,
          retroactivityValue: retroactivityValue,
          retroactivityRemoteValue: retroactivityRemoteValue,
          retroactivityDateFrom: retroactivityDateFrom,
          haveWithdrawal: haveWithdrawal,
          withdrawalValue: withdrawalValue,
          filterByBranches: filterByBranches,
          takeOnlyRandomizedPatients: applyOnRandomizedPatients,
          applyEachXItems: applyEachXItems,
          capToApply: capToApply,
          applyToFailvisitExecution: applyToFailvisitExecution,
          branches: branches || [],
          applyWithholdingOnConceptValues: applyWithholdingOnConceptValues,

          // end added fields
          concepts: conceptAssociated || [],
          paymentSchedule: conceptPaymentSchedule?.map((schedule: ContractConceptPaymentSchedule) => {
            return {
              id: schedule.id,
              stage: schedule.stage,
              isSelected: schedule.isSelected,
              isUnselected: schedule.isUnselected,
              contractConceptId: props.ContractConceptId!,
              contractStageId: schedule.contractStageId,
              amountExpected: schedule.amountExpected,
              screeningFailurePrice: schedule.screeningFailurePrice,
              settlementCoefficient: schedule.settlementCoefficient,
              price: schedule.price,
              remotePrice: schedule.remotePrice,
              phonePrice: schedule.phonePrice,
              currency: currency!,
              followUpPrice: schedule.followUpPrice,
              settlementRemoteCoefficient: schedule.settlementRemoteCoefficient,
              settlementPhoneCoefficient: schedule.settlementPhoneCoefficient,
              settlementFollowUpCoefficient: schedule.settlementFollowUpCoefficient,
              settlementScreeningFailureCoefficient: schedule.settlementScreeningFailureCoefficient,
              priceWithoutOverhead: schedule.priceWithoutOverhead
            }
          }) || []
        };
        props.UpdateContractConcept(CurrentValues as ContractConcept);
      } else {
        CurrentValues = {
          contractId: props.ContractId,
          contractAddendumId: props.ContractAddendumId,
          conceptId: conceptId!,
          concept: {
            id: conceptId!,
            conceptName: conceptName!,
            conceptDescription: conceptDescription!,
            conceptReferenceId: '1'
          },
          conceptCurrency: currency!,
          isIncludeInVisit: isIncludeInVisit,
          groupWithInTheVisit: groupWithInTheVisit ?? false,
          isOptional: isOptional,
          isManagedByCoordinator: isManagedByCoordinator,
          applyToRemoteExecution: applyToRemoteExecution,
          applyToInFaceExecution: applyToInFaceExecution,
          applyToPhoneExecution: applyToPhoneExecution,
          applyToPreScreeningExecution: applyToPreScreeningExecution,
          applyToScreeningExecution: applyToScreeningExecution,
          applyToRandomizationExecution: applyToRandomizationExecution,
          applyToTreatmentExecution: applyToTreatmentExecution,
          applyToFollowUpExecution: applyToFollowUpExecution,
          applyToUnScheduledExecution: applyToUnScheduledExecution,
          applyToEarlyTerminationExecution: applyToEarlyTerminationExecution,
          applyToFailvisitExecution: applyToFailvisitExecution,
          haveDivisionFee: haveDivisionFee,
          divisionFeeValue: divisionFeeValue!,
          isMedicalService: isMedicalService!,
          medicalServiceId: medicalServiceId!,
          settlementSetting: settlementSetting!,
          settlementPeriod: settlementPeriod!,
          valuationType: valuationType!,
          priceValue: priceValue!,
          phoneFixedValue: phoneFixedValue,
          remoteFixedValue: remoteFixedValue,
          haveRepetitionPrice: haveRepetitionPrice!,
          repetitionPriceValue: repetitionPriceValue!,
          haveEarlyDiscontinuationPrice: haveEarlyDiscontinuationPrice!,
          earlyDiscontinuationPrice: earlyDiscontinuationPrice!,
          percentageValue: percentageValue!,
          percentageBase: percentageBase!,
          maxCostPrice: maxCostPrice!,
          priceListOrigin: priceListOrigin!,
          haveCost: haveCost!,
          costSetting: costSetting!,
          serviceCategory: serviceCategory && serviceCategory.length > 0 ? serviceCategory[0] : undefined,
          percentageCostValue: percentageCostValue!,
          fixedCostValue: fixedCostValue!,
          costPriceListOrigin: costPriceListOrigin!,
          costProviderId: costProviderId!,
          amountToIncludePerSettlement: amountToIncludePerSettlement!,
          excludeParticularPatient: excludeParticularPatient!,
          takeOnlyParticularPatient: takeOnlyParticularPatient!,
          calculateType: calculateType!,
          needAgrupation: needAggrupation!,
          agroupationSegment: aggrupationSegment!,
          quantityToSettle: quantityToSettle!,
          maxQuantityToSettle: maxQuantityToSettle!,
          capToApply: capToApply,
          takeOnlyRandomizedPatients: applyOnRandomizedPatients,
          applyEachXItems: applyEachXItems,
          haveGenderFilter: haveGenderFilter!,
          appliesToMen: appliesToMen!,
          appliesToWomen: appliesToWomen!,
          appliesToWomenOfFertileAge: appliesToWomenOfFertileAge!,
          appliesToWomenOfNonFertileAge: appliesToWomenOfNonFertileAge!,
          appliesToAgeBetween: appliesBetweenAges,
          ageFrom: appliesAgesFrom,
          ageTo: appliesAgesTo,
          haveOverhead: haveOverhead,
          overheadValue: overheadValue,
          averageOverheadValue: averageOverheadValue,
          ignoreDecimal: ignoreDecimal,
          // added fields
          initialPeriodDate: initialPeriodDate,
          haveRetroactivity: haveRetroactivity,
          retroactivityValue: retroactivityValue,
          retroactivityRemoteValue: retroactivityRemoteValue,
          retroactivityDateFrom: retroactivityDateFrom,
          haveWithdrawal: haveWithdrawal,
          withdrawalValue: withdrawalValue,
          filterByBranches: filterByBranches,
          branches: branches || [],
          visitConceptRelationship: visitConceptRelationship,
          applyWithholdingOnConceptValues: applyWithholdingOnConceptValues,

          // end added fields
          concepts: conceptAssociated || [],
          paymentSchedule: conceptPaymentSchedule?.map((schedule: ContractConceptPaymentSchedule) => {
            return {
              id: schedule.id,
              stage: schedule.stage,
              isSelected: schedule.isSelected,
              isUnselected: schedule.isUnselected,
              contractConceptId: props.ContractConceptId!,
              contractStageId: schedule.contractStageId,
              amountExpected: schedule.amountExpected,
              screeningFailurePrice: schedule.screeningFailurePrice,
              settlementCoefficient: schedule.settlementCoefficient,
              price: schedule.price,
              remotePrice: schedule.remotePrice,
              phonePrice: schedule.phonePrice,
              currency: currency!,
              followUpPrice: schedule.followUpPrice,
              settlementRemoteCoefficient: schedule.settlementRemoteCoefficient,
              settlementPhoneCoefficient: schedule.settlementPhoneCoefficient,
              settlementFollowUpCoefficient: schedule.settlementFollowUpCoefficient,
              settlementScreeningFailureCoefficient: schedule.settlementScreeningFailureCoefficient,
              priceWithoutOverhead: schedule.priceWithoutOverhead
            }
          }) || []
        }
        props.AddContractConcept(props.ContractAddendumId, CurrentValues as NewContractConcept);
      }
    }
  };

  const HandleCancelForm = () => {
    ResetForm();
    props.dismissPanel();
  };

  const leftScroll = useScrollShadow();
  const rightScroll = useScrollShadow();

  const formFields = (
    <div className='flowcharSelector'>
      <div
        ref={leftScroll.ref}
        className={`ScrollShadow${leftScroll.showTop ? ' shadow-top' : ''}${leftScroll.showBottom ? ' shadow-bottom' : ''}`}
        onScroll={leftScroll.onScroll}
      >
        <Field label={t('conceptForm.formFields.conceptName')}>
          <Input
            value={conceptName || ''}
            onChange={(ev, data) => setConceptName(data.value)}
          />
        </Field>
        <Field label={t('conceptForm.formFields.description')}>
          <Textarea
            rows={3}
            value={conceptDescription || ''}
            onChange={(ev, data) => setConceptDescription(data.value)}
          />
        </Field>
        <Field>
          <Switch
            label={t('conceptForm.formFields.isManagedByCoordinator')}
            checked={isManagedByCoordinator}
            onChange={(ev, data) => setIsManagedByCoordinator(data.checked)}
          />
        </Field>
        <Separator />
        <Checkbox
          label={t('conceptForm.formFields.joinMedicalService')}
          checked={isMedicalService}
          onChange={(ev, data) => setIsMedicalService(data.checked as boolean)}
        />
        {isMedicalService && (
          <>
            <MedicalServiceSelectorComponent
              onSelectedServices={(services: AvailableMedicalService[] | undefined) => onChangeMedicalServiceIdSelection(services?.[0])}
              MedicalServicesSelectedIds={medicalServiceId ? [medicalServiceId] : []}
              MultiselectEnable={false}
            />
          </>)
        }
        <Separator />
        <Field label={t('conceptForm.formFields.settlement')}>
          <Combobox
            value={settlementSettingOptionSelected ? t(settlementSettingOptionSelected.text) : ''}
            selectedOptions={settlementSetting ? [settlementSetting.toString()] : []}
            onOptionSelect={(event, data) => {
              const selectedKey = data.optionValue;
              const selectedOption = ComponentFunctions.SettlementOptions.find(opt => opt.key.toString() === selectedKey);
              setSettlementSettingOptionSelected(selectedOption);
              setSettlementSetting(Number(selectedKey) || undefined);
            }}
          >
            {ComponentFunctions.SettlementOptions.map((option: ComponentFunctions.ISettlementOption) => (
              <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                {t(option.text)}
              </Option>
            ))}
          </Combobox>
        </Field>
        {settlementSetting === 7 && (
          <>
            <Field>
              <Switch
                label={'Aplicar solo a pacientes randomizados'}
                checked={applyOnRandomizedPatients}
                onChange={(ev, data) => {
                  setApplyOnRandomizedPatients(data.checked);
                  if (!data.checked) {
                    setApplyEachXItems(undefined);
                  }
                }}
              />
            </Field>
            {applyOnRandomizedPatients && (
              <Field label={'Aplicar cada X ítems'}>
                <Input
                  type="number"
                  min={1}
                  value={applyEachXItems?.toString() || ''}
                  onFocus={(e) => e.target.select()}
                  onChange={(ev, data) => {
                    const value = data.value ? Number.parseInt(data.value, 10) : undefined;
                    setApplyEachXItems(value);
                  }}
                />
              </Field>

            )}
          </>
        )}
        {settlementSetting === 5 && (
          <>
            <Field label={t('conceptForm.formFields.settlementPeriod')}>
              <Combobox
                value={settlementPeriod ? t(ComponentFunctions.PeriodOptions.find(opt => opt.key.toString() === settlementPeriod.toString())?.text || '') : ''}
                selectedOptions={settlementPeriod ? [settlementPeriod.toString()] : []}
                onOptionSelect={(event, data) => {
                  setSettlementPeriod(Number(data.optionValue) || undefined);
                }}
              >
                {ComponentFunctions.PeriodOptions.map((option) => (
                  <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                    {t(option.text)}
                  </Option>
                ))}
              </Combobox>
            </Field>
            <DateTimeInput
              label={'Fecha desde que se contabiliza el período'}
              placeHolder={'ingrese una fecha'}
              selectedDate={initialPeriodDate ? new Date(initialPeriodDate) : new Date()}
              isSubmitted={false}
              isRequired={settlementSetting === 5}
              errorMessage={undefined}
              onSelectDate={(date: Date | null | undefined) => setInitialPeriodDate(date)}
            />
          </>
        )}
        {settlementSetting === 10 && (
          <ProtocolConceptMultiSelectorComponent
            concepts={props.Concepts || []}
            parentConceptId={props.Concept?.id}
            showPercentage={false}
            onAddConcept={onAddConceptToConcept}
            onDeleteConcept={onRemoveConceptFromConcept}
            onChangeConceptSelection={onChangeConceptSelection}
            selectedConceptIds={props.Concepts?.filter(concept => concept.isSelected)?.map(concept => concept.id) || []}
          />
        )}
        <Separator />
        <Field label={t('conceptForm.formFields.valorization')}>
          <Combobox
            value={valuationTypeOptionSelected ? t(valuationTypeOptionSelected.text) : ''}
            selectedOptions={valuationType !== undefined ? [valuationType.toString()] : []}
            onOptionSelect={(event, data) => {
              const selectedKey = data.optionValue;
              const selectedOption = ComponentFunctions.ValueOriginOptions.find(opt => opt.key === selectedKey);
              setValuationTypeOptionSelected(selectedOption);
              setValuationType(Number(selectedKey));
            }}
          >
            {ComponentFunctions.ValueOriginOptions.map((option: ComponentFunctions.IValueOriginOption) => (
              <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                {t(option.text)}
              </Option>
            ))}
          </Combobox>
        </Field>
        {!props.Contract?.contractCurrency && (
          <MessageComponent
            message={t('conceptForm.formFields.message')}
            type={MessageBarType.warning}
          />
        )}
        {(valuationTypeOptionSelected && (valuationTypeOptionSelected.key === '1' || valuationTypeOptionSelected.key === '2' || valuationTypeOptionSelected.key === '5')) && (
          <CurrencySelectorComponent
            defaultSelected={currency}
            onCurrencyChange={(currency) => setCurrency(currency)}
            errorMessage={undefined}
            label={"Moneda del concepto"} />
        )}
        {(valuationTypeOptionSelected && valuationTypeOptionSelected.key === '1') && (
          <div>
            <Field label={t('conceptForm.formFields.value')}>
              <Input
                type="text"
                inputMode="decimal"
                contentAfter={currency}
                value={priceValueStr}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setPriceValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setPriceValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(priceValueStr);
                  const n = Number.isNaN(parsed) ? 0 : parsed;
                  setPriceValue(n);
                  setPriceValueStr(n.toString());
                }}
              />
            </Field>
            <Field label="Valor remoto">
              <Input
                type="text"
                inputMode="decimal"
                contentAfter={currency}
                value={remoteFixedValueStr}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setRemoteFixedValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setRemoteFixedValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(remoteFixedValueStr);
                  const n = Number.isNaN(parsed) ? 0 : parsed;
                  setRemoteFixedValue(n);
                  setRemoteFixedValueStr(n.toString());
                }}
              />
            </Field>
            <Field label="Valor telefónico">
              <Input
                type="text"
                inputMode="decimal"
                contentAfter={currency}
                value={phoneFixedValueStr}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setPhoneFixedValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setPhoneFixedValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(phoneFixedValueStr);
                  const n = Number.isNaN(parsed) ? 0 : parsed;
                  setPhoneFixedValue(n);
                  setPhoneFixedValueStr(n.toString());
                }}
              />
            </Field>
          </div>
        )}
        {valuationTypeOptionSelected && valuationTypeOptionSelected.key === '3' && (
          <div>
            <Field label={t('conceptForm.formFields.value')}>
              <Input
                type="text"
                inputMode="decimal"
                contentAfter="%"
                value={percentageValueStr}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setPercentageValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setPercentageValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(percentageValueStr);
                  if (!Number.isNaN(parsed)) {
                    setPercentageValue(parsed);
                    setPercentageValueStr(parsed.toString());
                  }
                }}
              />
            </Field>
            <Field label={t('conceptForm.formFields.percentageBase')}>
              <RadioGroup
                value={percentageBase?.toString()}
                onChange={(ev, data) => {
                  const selectedKey = data.value;
                  const selectedOption = ComponentFunctions.PercentageOriginOptions.find(opt => opt.key === selectedKey);
                  setPercetageBaseOptionSelected(selectedOption);
                  setPercentageBase(Number(selectedKey) || undefined);
                }}
              >
                {ComponentFunctions.PercentageOriginOptions.map((option) => (
                  <Radio key={option.key} value={option.key} label={option.text} />
                ))}
              </RadioGroup>
            </Field>

            {(percetageBaseOptionSelected?.takeFromConcepts) && (
              <>
                <Label>{t('conceptForm.formFields.percentageConcept')}</Label>
                <ProtocolConceptMultiSelectorComponent
                  concepts={props.Concepts || []}
                  parentConceptId={props.Concept?.id}
                  showPercentage={false}
                  onAddConcept={onAddConceptToConcept}
                  onDeleteConcept={onRemoveConceptFromConcept}
                  onChangeConceptSelection={onChangeConceptSelection}
                  selectedConceptIds={props.Concepts?.filter(concept => concept.isSelected)?.map(concept => concept.id) || []}
                />
                <small>
                  {t('conceptForm.formFields.applyPercentage')}
                </small>
              </>
            )}
          </div>
        )}
        {valuationTypeOptionSelected?.key === '2' && (
          <>
            <Field label={t('conceptForm.formFields.contractValue')}>
              <Input
                type="number"
                contentAfter={currency}
                defaultValue={maxCostPrice?.toString()}
                onChange={(ev, data) => {
                  const value = data.value ? Number.parseFloat(data.value) : undefined;
                  setMaxCostPrice(value);
                }}
              />
            </Field>
            <Text>
              {t('conceptForm.formFields.contractMessage')}
            </Text>
          </>
        )}
        {valuationTypeOptionSelected?.key === '4' && !isMedicalService &&
          <MessageComponent
            message={t('conceptForm.formFields.priceMessage')}
            type={MessageBarType.error}
          />
        }
        {(valuationTypeOptionSelected?.key === '4' || (valuationTypeOptionSelected?.isPercentage && percetageBaseOptionSelected?.takeFromPriceList)) && isMedicalService && (
          <Field label={t('conceptForm.formFields.priceListOrigin')}>
            <Combobox
              value={priceListOrigin ? ComponentFunctions.PriceListOptions.find(opt => opt.key.toString() === priceListOrigin.toString())?.text || '' : ''}
              selectedOptions={priceListOrigin ? [priceListOrigin.toString()] : []}
              onOptionSelect={(event, data) => {
                setPriceListOrigin(Number(data.optionValue) || undefined);
              }}
            >
              {ComponentFunctions.PriceListOptions.map((option) => (
                <Option key={option.key} value={option.key.toString()} text={option.text}>
                  {option.text}
                </Option>
              ))}
            </Combobox>
          </Field>
        )}
        <Field>
          <Switch label={t('conceptForm.formFields.ignoreDecimal')} checked={ignoreDecimal} onChange={(ev, data) => setIgnoreDecimal(data.checked)} />
        </Field>
        <Separator />
        <Field>
          <Switch
            label={t('conceptForm.formFields.haveWithholding')}
            checked={haveWithdrawal}
            onChange={(ev, data) => setHaveWithdrawal(data.checked)}
          />
        </Field>
        {haveWithdrawal && (
          <>
            <Field label={t('conceptForm.formFields.withholdingPercentage')}>
              <Input
                type="text"
                inputMode="decimal"
                value={withdrawalValueStr}
                contentAfter="%"
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setWithdrawalValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setWithdrawalValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(withdrawalValueStr);
                  if (!Number.isNaN(parsed)) {
                    setWithdrawalValue(parsed);
                    setWithdrawalValueStr(parsed.toString());
                  }
                }}
              />
            </Field>
            <Separator />
          </>
        )}
        <Field>
          <Switch
            label={t('conceptForm.formFields.groupWithInTheVisit')}
            checked={groupWithInTheVisit}
            onChange={(ev, data) => setGroupWithInTheVisit(data.checked)}
          />
        </Field>
        <Field>
          <Switch
            label={t('conceptForm.formFields.isIncludedInVisit')}
            checked={isIncludeInVisit}
            onChange={(ev, data) => setIsIncludeInVisit(data.checked)}
          />
        </Field>
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.isOptional')} checked={isOptional} onChange={(ev, data) => setIsOptional(data.checked)} />
        </Field>
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.applyToRemoteExecution')} checked={applyToRemoteExecution} onChange={(ev, data) => setApplyToRemoteExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.applyToInFaceExecution')} checked={applyToInFaceExecution} onChange={(ev, data) => setApplyToInFaceExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.applyToPhoneExecution')} checked={applyToPhoneExecution} onChange={(ev, data) => setApplyToPhoneExecution(data.checked)} />
        </Field>
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.applyToPreScreeningExecution')} checked={applyToPreScreeningExecution} onChange={(ev, data) => setApplyToPreScreeningExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.applyToScreeningExecution')} checked={applyToScreeningExecution} onChange={(ev, data) => setApplyToScreeningExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.applyToRandomizationExecution')} checked={applyToRandomizationExecution} onChange={(ev, data) => setApplyToRandomizationExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.applyToTreatmentExecution')} checked={applyToTreatmentExecution} onChange={(ev, data) => setApplyToTreatmentExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.applyToFollowUpExecution')} checked={applyToFollowUpExecution} onChange={(ev, data) => setApplyToFollowUpExecution(data.checked)} />
        </Field>
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.applyToUnScheduledExecution')} checked={applyToUnScheduledExecution} onChange={(ev, data) => setApplyToUnScheduledExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.applyToEarlyTerminationExecution')} checked={applyToEarlyTerminationExecution} onChange={(ev, data) => setApplyToEarlyTerminationExecution(data.checked)} />
        </Field>
        <Field>
          <Switch label={'Aplicar a visitas fallidas'} checked={applyToFailvisitExecution} onChange={(ev, data) => setApplyToFailvisitExecution(data.checked)} />
        </Field>
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.filterByBranches')} checked={filterByBranches} onChange={(ev, data) => setFilterByBranches(data.checked)} />
        </Field>
        {filterByBranches && (
          <>
            <ContractBranchSelectorComponent
              ContractId={props.ContractId}
              AddendumId={props.ContractAddendumId}
              onSelectedContractBranch={(selectedBranches: ContractBranch[]) => handleBranchSelection(selectedBranches.map(branch => (

                {
                  id: (branches || []).find((b: ConceptBranch) => b.branchId === branch.id)?.id || 0,
                  contractConceptId: props.ContractConceptId || AddedConceptId || 0,
                  branchId: branch.id,
                  branchName: branch.branchName,
                  branchDescription: branch.branchDescription
                })))}
              ContractBranchesSelected={(branches || []).map(branch => branch.branchId)}
              MultiselectEnable={true}
            />
            <Separator />
          </>
        )}
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.haveDivisionFee')} checked={haveDivisionFee} onChange={(ev, data) => setHaveDivisionFee(data.checked)} />
        </Field>
        {haveDivisionFee && (
          <>
            <Field label={t('conceptForm.formFields.divisionFeeValue')}
              hint={<span>Porcentual institución <strong>{divisionFeeValue}%</strong>&nbsp;-&nbsp;Porcentual Investigador Principal <strong>{100 - divisionFeeValue}%</strong></span>}>
              <Input
                type="text"
                inputMode="decimal"
                contentAfter="%"
                value={divisionFeeValueStr}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setDivisionFeeValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setDivisionFeeValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(divisionFeeValueStr);
                  const n = Number.isNaN(parsed) ? 0 : parsed;
                  setDivisionFeeValue(n);
                  setDivisionFeeValueStr(n.toString());
                }}
              />
            </Field>
            <Separator />
          </>
        )}
        <Field>
          <Switch label={t('conceptForm.formFields.includedOverhead')} checked={haveOverhead} onChange={(ev, data) => setHaveOverhead(data.checked)} />
        </Field>
        {haveOverhead && (
          <>
            <Field label={t('conceptForm.formFields.overheadPercentage')}>
              <Input
                type="text"
                inputMode="decimal"
                value={averageOverheadValueStr}
                contentAfter="%"
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => {
                  setAverageOverheadValueStr(data.value);
                  const parsed = Number.parseFloat(data.value);
                  if (!Number.isNaN(parsed)) setAverageOverheadValue(parsed);
                }}
                onBlur={() => {
                  const parsed = Number.parseFloat(averageOverheadValueStr);
                  if (!Number.isNaN(parsed)) {
                    setAverageOverheadValue(parsed);
                    setAverageOverheadValueStr(parsed.toString());
                  }
                }}
              />
            </Field>
            {/* {valuationTypeOptionSelected && valuationTypeOptionSelected?.key === '5' && <>
              <Label>
                {t('conceptForm.formFields.noOverhead')} {priceValue && (priceValue - overheadValue).toFixed(2) + ' ' + props.Contract?.contractCurrency}
              </Label>
              <Label>
                {t('conceptForm.formFields.overheadValue')} {overheadValue.toFixed(2) + ' ' + props.Contract?.contractCurrency}
              </Label>
              <Separator />
            </>} */}
            <Separator />
          </>
        )}
        <Field>
          <Switch label={t('conceptForm.formFields.repeatPrice')} checked={haveRepetitionPrice} onChange={(ev, data) => setHaveRepetitionPrice(data.checked)} />
        </Field>
        {haveRepetitionPrice && (
          <Field label={t('conceptForm.formFields.additionalValue')}>
            <Input
              type="text"
              inputMode="decimal"
              value={repetitionPriceValueStr}
              contentAfter={currency}
              onFocus={(e) => e.target.select()}
              onChange={(ev, data) => {
                setRepetitionPriceValueStr(data.value);
                const parsed = Number.parseFloat(data.value);
                if (!Number.isNaN(parsed)) setRepetitionPriceValue(parsed);
              }}
              onBlur={() => {
                const parsed = Number.parseFloat(repetitionPriceValueStr);
                if (!Number.isNaN(parsed)) {
                  setRepetitionPriceValue(parsed);
                  setRepetitionPriceValueStr(parsed.toString());
                }
              }}
            />
          </Field>
        )}
        <Field>
          <Switch label={t('conceptForm.formFields.earlyDiscontinuationPrice')} checked={haveEarlyDiscontinuationPrice} onChange={(ev, data) => setHaveEarlyDiscontinuationPrice(data.checked)} />
        </Field>
        {haveEarlyDiscontinuationPrice && (
          <Field label={t('conceptForm.formFields.earlyDiscontinuationValue')}>
            <Input
              type="text"
              inputMode="decimal"
              value={earlyDiscontinuationPriceStr}
              contentAfter={currency}
              onFocus={(e) => e.target.select()}
              onChange={(ev, data) => {
                setEarlyDiscontinuationPriceStr(data.value);
                const parsed = Number.parseFloat(data.value);
                if (!Number.isNaN(parsed)) setEarlyDiscontinuationPrice(parsed);
              }}
              onBlur={() => {
                const parsed = Number.parseFloat(earlyDiscontinuationPriceStr);
                if (!Number.isNaN(parsed)) {
                  setEarlyDiscontinuationPrice(parsed);
                  setEarlyDiscontinuationPriceStr(parsed.toString());
                }
              }}
            />
          </Field>
        )}
        <Field>
          <Switch label={t('conceptForm.formFields.haveRetroaactivity')} checked={haveRetroactivity} onChange={(ev, data) => setHaveRetroactivity(data.checked)} />
        </Field>
        {haveRetroactivity && (
          <>
            <DateTimeInput
              label={t('conceptForm.formFields.retroactivityDateFrom')}
              placeHolder={'ingrese una fecha'}
              selectedDate={retroactivityDateFrom ? new Date(retroactivityDateFrom) : new Date()}
              isSubmitted={false}
              isRequired={settlementSetting === 5}
              errorMessage={undefined}
              onSelectDate={(date: Date | null | undefined) => setRetroactivityDateFrom(date)}
            />
            <Separator />
          </>
        )}
        <Separator />
        <Label>{t('conceptForm.formFields.applicationCriteria')}</Label>
        <Field>
          <Switch label={t('conceptForm.formFields.appliesToMen')} checked={appliesToMen} onChange={(ev, data) => setAppliesToMen(data.checked)} />
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.appliestoWomen')} checked={appliesToWomen} onChange={(ev, data) => setAppliesToWomen(data.checked)} />
        </Field>
        {appliesToWomen && (
          <>
            <Field>
              <Switch label={t('conceptForm.formFields.womenFertileAge')} checked={appliesToWomenOfFertileAge} onChange={(ev, data) => setAppliesToWomenOfFertileAge(data.checked)} />
            </Field>
            <Field>
              <Switch label={t('conceptForm.formFields.womenOfNonFertileAge')} checked={appliesToWomenOfNonFertileAge} onChange={(ev, data) => setAppliesToWomenOfNonFertileAge(data.checked)} />
            </Field>
          </>
        )}
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.applieBetweenAges')} checked={appliesBetweenAges} onChange={(ev, data) => setAppliesBetweenAges(data.checked)} />
        </Field>
        {appliesBetweenAges && (
          <>
            <Field label={t('conceptForm.formFields.ageRangefrom')}>
              <Input
                type="number"
                value={appliesAgesFrom?.toString()}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => setAppliesAgesFrom(Number(data.value))}
              />
            </Field>
            <Field label={t('conceptForm.formFields.ageRangeto')}>
              <Input
                type="number"
                value={appliesAgesTo?.toString()}
                onFocus={(e) => e.target.select()}
                onChange={(ev, data) => setAppliesAgesTo(Number(data.value))}
              />
            </Field>
          </>
        )}
        <Separator />
        <Field label={t('conceptForm.formFields.quantityToSettle')}>
          <Input
            type="number"
            contentAfter='Cantidad'
            value={quantityToSettle?.toString()}
            onFocus={(e) => e.target.select()}
            onChange={(ev, data) => setQuantityToSettle(Number(data.value))}
          />
        </Field>
        <Separator />
        <Field label={t('conceptForm.formFields.calculateType')}>
          <Combobox
            value={calculateType ? t(ComponentFunctions.calculateTypeOptions.find(opt => opt.key.toString() === calculateType.toString())?.text || '') : ''}
            selectedOptions={calculateType ? [calculateType.toString()] : []}
            onOptionSelect={(event, data) => {
              setCalculateType(Number(data.optionValue) || undefined);
            }}
          >
            {ComponentFunctions.calculateTypeOptions.map((option) => (
              <Option key={option.key} value={option.key.toString()} text={t(option.text) || ''}>
                {t(option.text)}
              </Option>
            ))}
          </Combobox>
        </Field>
        <Field>
          <Switch label={t('conceptForm.formFields.needAgrupation')} checked={needAggrupation} onChange={(ev, data) => setNeedAggrupation(data.checked)} />
        </Field>
        {needAggrupation && (
          <Field label={t('conceptForm.formFields.agroupationSegment')}>
            <Input
              type="number"
              contentAfter={t(ComponentFunctions.getCalculateTypeDescription(calculateType))}
              value={aggrupationSegment?.toString()}
              onFocus={(e) => e.target.select()}
              onChange={(ev, data) => setAggrupationSegment(Number(data.value))}
            />
          </Field>
        )}
        <Field>
          <Switch label={t('conceptForm.formFields.excludeParticularPatient')} checked={excludeParticularPatient} onChange={(ev, data) => setExcludeParticularPatient(data.checked)} />
        </Field>
        <Separator />
        <Field>
          <Switch label={t('conceptForm.formFields.haveCost')} checked={haveCost} onChange={(ev, data) => setHaveCost(data.checked)} />
        </Field>
        {
          haveCost && (
            <>
              <Field label={t('conceptForm.formFields.conceptCost')}>
                <Combobox
                  value={costSettingOptionSelected ? costSettingOptionSelected.text : ''}
                  selectedOptions={costSetting ? [costSetting.toString()] : []}
                  onOptionSelect={(event, data) => {
                    const selectedKey = data.optionValue;
                    const selectedOption = ComponentFunctions.ConceptCostOptions.find(opt => opt.key.toString() === selectedKey);
                    setCostSettingOptionSelected(selectedOption);
                    setCostSetting(Number(selectedKey) || undefined);
                  }}
                >
                  {ComponentFunctions.ConceptCostOptions.map((option) => (
                    <Option key={option.key} value={option.key.toString()} text={option.text}>
                      {option.text}
                    </Option>
                  ))}
                </Combobox>
              </Field>
              {costSettingOptionSelected?.isFixedPrice && (
                <Field label={t('conceptForm.formFields.costValue')}>
                  <Input
                    type="text"
                    inputMode="decimal"
                    value={fixedCostValueStr}
                    contentAfter={currency}
                    onFocus={(e) => e.target.select()}
                    onChange={(ev, data) => {
                      setFixedCostValueStr(data.value);
                      const parsed = Number.parseFloat(data.value);
                      if (!Number.isNaN(parsed)) setFixedCostValue(parsed);
                    }}
                    onBlur={() => {
                      const parsed = Number.parseFloat(fixedCostValueStr);
                      if (!Number.isNaN(parsed)) {
                        setFixedCostValue(parsed);
                        setFixedCostValueStr(parsed.toString());
                      }
                    }}
                  />
                </Field>
              )}
              {costSettingOptionSelected?.isPercentage && (
                <Field label={t('conceptForm.formFields.costValue')}>
                  <Input
                    type="text"
                    inputMode="decimal"
                    value={fixedCostValueStr}
                    contentAfter='%'
                    onFocus={(e) => e.target.select()}
                    onChange={(ev, data) => {
                      setFixedCostValueStr(data.value);
                      const parsed = Number.parseFloat(data.value);
                      if (!Number.isNaN(parsed)) setFixedCostValue(parsed);
                    }}
                    onBlur={() => {
                      const parsed = Number.parseFloat(fixedCostValueStr);
                      if (!Number.isNaN(parsed)) {
                        setFixedCostValue(parsed);
                        setFixedCostValueStr(parsed.toString());
                      }
                    }}
                  />
                </Field>
              )}
              {costSettingOptionSelected?.isPriceList && !isMedicalService &&
                <MessageComponent
                  message={t('conceptForm.formFields.priceMessage')}
                  type={MessageBarType.error}
                />
              }
              {costSettingOptionSelected?.isPriceList && isMedicalService && (
                <Field label={t('conceptForm.formFields.selectPriceList')}>
                  <Combobox
                    value={costPriceListOrigin ? ComponentFunctions.OriginConceptCostOptions.find(opt => opt.key.toString() === costPriceListOrigin.toString())?.text || '' : ''}
                    selectedOptions={costPriceListOrigin ? [costPriceListOrigin.toString()] : []}
                    onOptionSelect={(event, data) => {
                      setCostPriceListOrigin(Number(data.optionValue) || undefined);
                    }}
                  >
                    {ComponentFunctions.OriginConceptCostOptions.map((option) => (
                      <Option key={option.key} value={option.key.toString()} text={option.text}>
                        {option.text}
                      </Option>
                    ))}
                  </Combobox>
                </Field>
              )}

              {costSettingOptionSelected?.isPriceList && costPriceListOrigin === 2 && isMedicalService && (
                <>
                  <Label>{t('conceptForm.formFields.provider')}</Label>
                  <ProviderSelectorComponent MultiselectEnable={false} ProviderSelected={[]} />
                </>
              )}

              {costSettingOptionSelected?.isTakeFromServices && (
                <>
                  <ServiceCategorySelectorComponent
                    onSelectedServiceCategory={(categories: ServiceCategory[]) => {
                      console.log('ServiceCategory selected:', categories);
                      // Extraer los IDs (strings) de las categorías seleccionadas
                      const categoryIds = categories.map(cat => cat.id);
                      setServiceCategory(categoryIds);
                    }}
                    ServiceCategoriesSelected={serviceCategory}
                    MultiselectEnable={false}
                    showLabel={true}
                    showManageButton={true}
                  />
                </>
              )}
            </>
          )
        }
      </div>
      {(settlementSettingOptionSelected?.key === '4' || valuationTypeOptionSelected?.key === '5') && (
        <div
          ref={rightScroll.ref}
          className={`flowcharContainer ScrollShadow${rightScroll.showTop ? ' shadow-top' : ''}${rightScroll.showBottom ? ' shadow-bottom' : ''}`}
          onScroll={rightScroll.onScroll}
        >
          {/* <Label>{t('conceptForm.formFields.flowChart')}</Label> */}
          <div className="FlowChart">
            <ContractStageMultiSelectorComponent
              ContractId={props.ContractId}
              ContractAddendumId={props.ContractAddendumId}
              ContractConceptId={props.ContractConceptId || AddedConceptId}
              ShowInputValues={valuationTypeOptionSelected?.key === '5' ? true : false}
              ConceptSaved={ContractConceptSaved}
              currency={currency}
              applyToRemoteExecution={applyToRemoteExecution}
              applyToInFaceExecution={applyToInFaceExecution}
              applyToPhoneExecution={applyToPhoneExecution}
              applyToFailvisitExecution={applyToFailvisitExecution}
              applyToFollowUpExecution={applyToFollowUpExecution}
              OnAllSaved={onFinishedSavingHandler}

            />
          </div>
        </div>
      )}
    </div>
  );

  // form validation

  const ValidateForm = (): boolean => {
    let validationResult: boolean = true;

    let FormValidation: FormValidation = { success: true, errors: [] };
    setFormValidationStatus(FormValidation);

    FormValidation.success = validationResult;
    setFormValidationStatus(FormValidation);
    return validationResult;
  };

  return (
    <Drawer
      open={props.isOpen}
      onOpenChange={(_, { open }) => {
        if (!open) {
          ResetForm();
          props.dismissPanel();
        }
      }}
      position="end"
      // size={(settlementSettingOptionSelected?.key === '4' || valuationTypeOptionSelected?.key === '5') ? 'large' : 'medium'}
      className={styles.drawer}
      style={(settlementSettingOptionSelected?.key === '4' || valuationTypeOptionSelected?.key === '5') ? { width: `80vw` } : { width: '30vw' }}
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label="Close"
              icon={<Dismiss24Regular />}
              onClick={props.dismissPanel}
            />
          }
        >
          {t('conceptForm.panel.visitInformation')}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody>
        {submittedForm && !FormValidationStatus?.success && (
          <MessageBar intent="error">
            <MessageBarBody>
              <MessageBarTitle>{t('conceptForm.panel.reviewInformation')}</MessageBarTitle>
              <ul>
                {FormValidationStatus?.errors.map(
                  (Error: string, index: number) => (
                    <li key={index}>{Error}</li>
                  )
                )}
              </ul>
            </MessageBarBody>
          </MessageBar>
        )}
        {props.failOnAdding &&
          props.error && (
            <ErrorMessageComponent Error={props.error} />
          )}
        {formFields}
      </DrawerBody>
      <DrawerFooter>
        <Button onClick={HandleCancelForm} appearance="secondary">
          <Trans i18nKey={'conceptForm.footer.cancelButton'} />
        </Button>
        <Button
          onClick={HandleSaveForm}
          appearance="primary"
          disabled={props.isAdding || props.isUpdating || savingSchedules}
          icon={props.isAdding || props.isUpdating || savingSchedules ? <Spinner size="extra-tiny" /> : undefined}
        >
          {props.isAdding || props.isUpdating ? <Trans i18nKey={'conceptForm.footer.saving'} /> : <Trans i18nKey={'conceptForm.footer.saveButton'} />}
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default connect(
  ComponentFunctions.mapStateToProps,
  ComponentFunctions.mapDispatchToProps
)(ConceptFormComponent as any);
